import { render } from "./TCSPromoHeroSection.vue?vue&type=template&id=789e5022&scoped=true"
import script from "./TCSPromoHeroSection.vue?vue&type=script&lang=js"
export * from "./TCSPromoHeroSection.vue?vue&type=script&lang=js"

import "./TCSPromoHeroSection.vue?vue&type=style&index=0&id=789e5022&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789e5022"]])

export default __exports__